import contentType from './contentType'
import {
  formatCity,
  getBranchId
} from '../../../util/methods'

const yearArr = [
  { id: 1, name: '2019 至 2020 半财年报告' },
  { id: 2, name: '2020 全财年报告' },
  { id: 3, name: '2021 全财年报告' },
  { id: 4, name: '2022 全财年报告' },
  { id: 5, name: '2023 全财年报告' }
]
const yearMap = new Map(yearArr.map(item => [item.id, item]))

let recordId = 0

const dataArr = [
  // 北京分会
  { id: recordId++, branchId: getBranchId('beijing'), yearId: 1, com: contentType.beijing2019 },
  { id: recordId++, branchId: getBranchId('beijing'), yearId: 2, com: contentType.beijing2020 },
  { id: recordId++, branchId: getBranchId('beijing'), yearId: 3, com: contentType.beijing2021 },
  { id: recordId++, branchId: getBranchId('beijing'), yearId: 4, com: contentType.beijing2022 },
  { id: recordId++, branchId: getBranchId('beijing'), yearId: 5, com: contentType.beijing2023 },

  // 成都分会
  { id: recordId++, branchId: getBranchId('chengdu'), yearId: 1, com: contentType.chengdu2019 },
  { id: recordId++, branchId: getBranchId('chengdu'), yearId: 2, com: contentType.chengdu2020 },
  { id: recordId++, branchId: getBranchId('chengdu'), yearId: 3, com: contentType.chengdu2021 },
  { id: recordId++, branchId: getBranchId('chengdu'), yearId: 4, com: contentType.chengdu2022 },
  { id: recordId++, branchId: getBranchId('chengdu'), yearId: 5, com: contentType.chengdu2023 },

  // 广州分会
  { id: recordId++, branchId: getBranchId('guangzhou'), yearId: 1, com: contentType.guangzhou2019 },
  { id: recordId++, branchId: getBranchId('guangzhou'), yearId: 2, com: contentType.guangzhou2020 },
  { id: recordId++, branchId: getBranchId('guangzhou'), yearId: 3, com: contentType.guangzhou2021 },
  { id: recordId++, branchId: getBranchId('guangzhou'), yearId: 4, com: contentType.guangzhou2022 },
  { id: recordId++, branchId: getBranchId('guangzhou'), yearId: 5, com: contentType.guangzhou2023 },

  // 杭州分会
  { id: recordId++, branchId: getBranchId('hangzhou'), yearId: 1, com: contentType.hangzhou2019 },
  { id: recordId++, branchId: getBranchId('hangzhou'), yearId: 2, com: contentType.hangzhou2020 },
  { id: recordId++, branchId: getBranchId('hangzhou'), yearId: 3, com: contentType.hangzhou2021 },
  { id: recordId++, branchId: getBranchId('hangzhou'), yearId: 4, com: contentType.hangzhou2022 },
  { id: recordId++, branchId: getBranchId('hangzhou'), yearId: 5, com: contentType.hangzhou2023 },

  // 南京分会
  { id: recordId++, branchId: getBranchId('nanjing'), yearId: 1, com: contentType.nanjing2019 },
  { id: recordId++, branchId: getBranchId('nanjing'), yearId: 2, com: contentType.nanjing2020 },
  { id: recordId++, branchId: getBranchId('nanjing'), yearId: 3, com: contentType.nanjing2021 },
  { id: recordId++, branchId: getBranchId('nanjing'), yearId: 4, com: contentType.nanjing2022 },
  { id: recordId++, branchId: getBranchId('nanjing'), yearId: 5, com: contentType.nanjing2023 },

  // 上海分会
  { id: recordId++, branchId: getBranchId('shanghai'), yearId: 1, com: contentType.shanghai2019 },
  { id: recordId++, branchId: getBranchId('shanghai'), yearId: 2, com: contentType.shanghai2020 },
  { id: recordId++, branchId: getBranchId('shanghai'), yearId: 3, com: contentType.shanghai2021 },
  { id: recordId++, branchId: getBranchId('shanghai'), yearId: 4, com: contentType.shanghai2022 },
  { id: recordId++, branchId: getBranchId('shanghai'), yearId: 5, com: contentType.shanghai2023 },

  // 深圳分会
  { id: recordId++, branchId: getBranchId('shenzhen'), yearId: 1, com: contentType.shenzhen2019 },
  { id: recordId++, branchId: getBranchId('shenzhen'), yearId: 2, com: contentType.shenzhen2020 },
  { id: recordId++, branchId: getBranchId('shenzhen'), yearId: 3, com: contentType.shenzhen2021 },
  { id: recordId++, branchId: getBranchId('shenzhen'), yearId: 4, com: contentType.shenzhen2022 },
  { id: recordId++, branchId: getBranchId('shenzhen'), yearId: 5, com: contentType.shenzhen2023 },

  // 苏州分会
  { id: recordId++, branchId: getBranchId('suzhou'), yearId: 1, com: contentType.suzhou2019 },
  { id: recordId++, branchId: getBranchId('suzhou'), yearId: 2, com: contentType.suzhou2020 },
  { id: recordId++, branchId: getBranchId('suzhou'), yearId: 3, com: contentType.suzhou2021 },
  { id: recordId++, branchId: getBranchId('suzhou'), yearId: 4, com: contentType.suzhou2022 },
  { id: recordId++, branchId: getBranchId('suzhou'), yearId: 5, com: contentType.suzhou2023 },

  // 台北分会
  { id: recordId++, branchId: getBranchId('taibei'), yearId: 1, com: contentType.taibei2019 },

  // 武汉分会
  { id: recordId++, branchId: getBranchId('wuhan'), yearId: 1, com: contentType.wuhan2019 },
  { id: recordId++, branchId: getBranchId('wuhan'), yearId: 2, com: contentType.wuhan2020 },
  { id: recordId++, branchId: getBranchId('wuhan'), yearId: 3, com: contentType.wuhan2021 },
  { id: recordId++, branchId: getBranchId('wuhan'), yearId: 4, com: contentType.wuhan2022 },
  { id: recordId++, branchId: getBranchId('wuhan'), yearId: 5, com: contentType.wuhan2023 },

  // 厦门分会
  { id: recordId++, branchId: getBranchId('xiamen'), yearId: 1, com: contentType.xiamen2019 },
  { id: recordId++, branchId: getBranchId('xiamen'), yearId: 2, com: contentType.xiamen2020 },
  { id: recordId++, branchId: getBranchId('xiamen'), yearId: 3, com: contentType.xiamen2021 },
  { id: recordId++, branchId: getBranchId('xiamen'), yearId: 4, com: contentType.xiamen2022 },
  { id: recordId++, branchId: getBranchId('xiamen'), yearId: 5, com: contentType.xiamen2023 },

  // 硅谷分会
  { id: recordId++, branchId: getBranchId('silicon'), yearId: 5, com: contentType.silicon2023 },

  // 新加坡分会
  { id: recordId++, branchId: getBranchId('singapore'), yearId: 5, com: contentType.singapore2023 }
]
// const dataMap = new Map(dataArr.map(item => [genarateCompositionId(item.branchId, item.yearId), item]))

// 基于分会 id 和年份 id, 生成组合 id
// function genarateCompositionId (branchId, yearId) {
//   return `${branchId}-${yearId}`
// }

/**
 * @desc 获取财务数据
 * @param {Object} opt
 * @param {Number} opt.branch_id
 * @param {Number} opt.year_id
 */
export function getFinanceData (opt) {
  // const cid = genarateCompositionId(opt.branch_id, opt.year_id)
  let data = dataArr.filter(item => item.branchId === opt.branch_id && item.yearId === opt.year_id)
  if (data && data.length) data = data[0]
  data = data || {}

  const year = yearMap.get(opt.year_id) || {}

  return Object.assign({}, data, { yearName: year.name || '' })
}

/**
 * @desc 获取当前账户下隶属的所有分会
 * @param {Object} opt
 * @param {Array} opt.allBranchArr 所有分会数组
 * @param {Array} opt.branchIdArr
 */
export function getFinanceBranchList ({ allBranchArr, branchIdArr }) {
  const arr = []

  branchIdArr.forEach(id => {
    allBranchArr.forEach(branch => {
      if (branch.id === id) {
        const branchInfo = {
          name: formatCity(branch.city, branch.province),
          id
        }

        arr.push(branchInfo)
      }
    })
  })

  return arr
}

/**
 * @desc 获取某分会下所有年份的 Tab list
 * @param {Object} opt
 * @param {Number} opt.branch_id
 */
export function getFinanceBranchYearList (opt) {
  const arr = dataArr.filter(item => item.branchId === opt.branch_id)

  if (!arr) {
    return []
  }

  return arr.map(item => {
    const year = yearMap.get(item.yearId) || {}

    return Object.assign({}, year)
  })
}
